import { useTranslation } from 'react-i18next'

import {
  Item,
  ItemActions,
  ItemContent,
  ItemMedia,
  ItemTitle,
} from '@ps/ds/components/blocks/Item/Item'
import {
  Accordion,
  AccordionContent,
  AccordionCustomTrigger,
  AccordionItem,
} from '@ps/ds/components/primitives/Accordion/Accordion'
import { PestShareLogo } from '@ps/ds/icons/PestShareLogo'
import { Card } from '@ps/ds/ui/card'
import { ChevronDown } from 'lucide-react'
import { NS } from 'src/constants/i18n'

import { PEST_SHARE_CONTACT } from '../constants/contact'
import { GenericContactGroup } from './GenericContactGroup'

export const PestShareContactAccordion = () => {
  const { t } = useTranslation(NS.TRACKING)

  return (
    <Card>
      <Accordion type="single" collapsible>
        <AccordionItem value="pest-share" className="last:border-b-0">
          <AccordionCustomTrigger className="[&[data-state=open]_.accordion-chevron]:rotate-180">
            <Item className="w-full md:flex-nowrap">
              <ItemMedia variant="badge">
                <ItemMedia variant="icon">
                  <div className="w-10 h-10 p-[10px] bg-gradient-orange rounded-full flex items-center justify-center">
                    <PestShareLogo className="text-primary-foreground" />
                  </div>
                </ItemMedia>
              </ItemMedia>

              <ItemContent className="min-w-0">
                <ItemTitle>
                  {t(`contact.options.contactProvider.label`, {
                    providerName: PEST_SHARE_CONTACT.providerName,
                  })}
                </ItemTitle>
              </ItemContent>

              <ItemActions>
                <ChevronDown size={20} className={'accordion-chevron transition-all'} />
              </ItemActions>
            </Item>
          </AccordionCustomTrigger>

          <AccordionContent className="pb-0">
            <GenericContactGroup hasLongTitle={false} />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Card>
  )
}
